module.exports = __webpack_public_path__ + "assets/assets/images/icons/icon-chevron-left.1a9b2783.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/icons/icon-chevron-left.svg
// module id = 337
// module chunks = 2